import { PromptTemplateCategory } from '../types';

export const professional: PromptTemplateCategory = {
  title: "专业",
  icon: "💼",
  templates: [
    {
      title: "YouTube / 视频脚本",
      content: `写一个由单人旁白的YouTube视频脚本。
- 视频主题是[远程办公时人们常犯的5个错误——以及如何改正]。
- 目标受众：[刚开始第一份远程工作的年轻专业人士]。
- 语气：[友好、对话式、实用——像来自可信赖同事的建议]。
- 结构上要有强有力的前两句钩子、各要点之间清晰的过渡、以及简短的结尾和行动号召。
- 为口语表达而写：使用简短段落和反问句来保持听众注意力。`
    },
    {
      title: "产品解说",
      content: `为产品解说视频写一段旁白脚本。
- 产品是[一款帮助小企业主通过扫描收据来追踪支出的手机应用]。
- 目标受众：[讨厌记账的自由职业者和小企业主]。
- 需要突出的主要优势：
  1. [2秒扫描收据——无需手动输入]。
  2. [智能建议自动分类支出]。
  3. [一键导出，轻松报税]。
- 语气：[清晰、积极、令人安心——让痛苦的任务变得简单]。
- 句子简洁有力，避免行话。`
    },
    {
      title: "演讲稿",
      content: `写一篇专业演讲或主题演讲稿。
- 场合是[公司全员大会，为新季度做动员]。
- 演讲者是[一位团队负责人，面对工程师、设计师和管理者的混合听众]。
- 核心信息：[庆祝上季度的成果、坦诚面对挑战、围绕未来几个月的明确重点凝聚团队]。
- 语气：[自信、真诚、鼓舞人心——不要官话套话]。
- 大约口语时长：[4分钟]。
- 使用对话式措辞、有策略的停顿和令人难忘的结尾语。`
    }
  ]
};
